export function initWebComponent(element, template, isHtml = true, withShadowRoot = false) {
    // No shadow
    if(withShadowRoot) {
        element.attachShadow({ mode: 'open'});
        element.shadowRoot.appendChild(template.content.cloneNode(true));
    }

    if(isHtml) {
        element.innerHTML = template.innerHTML
    } else {
        element.innerText = template.innerHTML
    }
}

export function getComponentsByName(name) {
    return document.querySelectorAll(name)
}
export function getComponentByName(name) {
    return document.querySelector(name)
}
